module.exports = __webpack_public_path__ + "img/3.bdadb436.png";